import _classCallCheck from '/app/node_modules/babel-runtime/helpers/classCallCheck';
import _createClass from '/app/node_modules/babel-runtime/helpers/createClass';
export var AuthenticationApi = function () {
    function AuthenticationApi(axios) {
        _classCallCheck(this, AuthenticationApi);

        this.axios = axios;
    }

    _createClass(AuthenticationApi, [{
        key: 'authLogin',
        value: function authLogin(data) {
            return this.axios.$post('/authentication/auth/login/', data);
        }
    }, {
        key: 'authLoginAd',
        value: function authLoginAd(data) {
            return this.axios.$post('/authentication/auth/login-ad/', data);
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword(data) {
            return this.axios.$post('/authentication/auth/forgotPassword/', data);
        }
    }, {
        key: 'loginOut',
        value: function loginOut(data) {
            return this.axios.$post('/authentication/auth/loginout/', data);
        }
    }, {
        key: 'updatePassword',
        value: function updatePassword(data) {
            return this.axios.$post('/authentication/auth/update-password', data);
        }
    }, {
        key: 'getAuthUrl',
        value: function getAuthUrl(data) {
            return this.axios.$post('/authentication/auth/get-url', data);
        }
    }, {
        key: 'getUserAD',
        value: function getUserAD(data) {
            return this.axios.$post('/authentication/auth/get-user', data);
        }
    }]);

    return AuthenticationApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/authentication.js
// module id = ./src/api/authentication.js
// module chunks = 34